import { Heading } from 'components/elements';
import { styled } from 'styles';

export const OverlayHeader = styled(Heading).attrs({
  size: 2,
})`
  margin-top: ${({ theme }) => theme.spacing.relative.large};
  text-align: center;
`;

export const OverlayImage = styled.div`
  color: ${({ theme }) => theme.severity.primary};
  max-width: min(25em, 80%);
  width: 100%;
`;

export const OverlayMessage = styled.div`
  font-size: 1.2em;
  margin-top: ${({ theme }) => theme.spacing.relative.smaller};
  text-align: center;
`;

export const StyledOverlay = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  grid-area: content;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.absolute.large};
  width: 100%;

  @media (max-width: 768px) {
    justify-content: unset;
    padding-top: 10vh;
  }
`;

OverlayHeader.displayName = 'OverlayHeader';
OverlayImage.displayName = 'OverlayImage';
OverlayMessage.displayName = 'OverlayMessage';
StyledOverlay.displayName = 'Overlay';
